import React, {PureComponent} from 'react';
import {connect} from 'react-redux';

import template from './TaxesFooter.rt';
import {getChangesCount} from "./TaxesReducer";
import {saveTaxLocations, handleCancelClick} from "./TaxesActions";
import TaxesRegions from "./TaxesRegions";

class TaxesFooter extends PureComponent {
  render = template
}

const mapStateToProps = (state) => {
  const {taxes} = state;
  return {
    updateItemCount: getChangesCount(taxes),
    currentGroup: taxes.currentGroup,
    materialItems: taxes.materialItems,
    laborItems: taxes.laborItems,
    level: taxes.level
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSave: (level) => dispatch(saveTaxLocations(TaxesRegions.currentRegion.name, TaxesRegions.currentRegion.getCurrentGroupAtLevel(level))),
    onCancel: () => dispatch(handleCancelClick())
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(TaxesFooter);

